/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit';
import {
  InitialStateNotification,
  HTTPErrorInfoEventType,
  HTTPErrorInfoEvent,
  Store,
} from '@/types';

export const initialState: InitialStateNotification = {
  HTTPErrorInfoEvent: {
    isOpen: false,
    type: '' as HTTPErrorInfoEventType,
  },
};

const STORE_HTTP_ERROR_INFO_EVENT = 'STORE_HTTP_ERROR_INFO_EVENT';

export const getHTPPErrorInfoEvent = (state: Store) =>
  state.notification.HTTPErrorInfoEvent;

export const storeHTPPErrorInfoEvent = createAction(
  STORE_HTTP_ERROR_INFO_EVENT,
  (payload: HTTPErrorInfoEvent) => ({
    payload,
  })
);

export default createReducer(initialState, {
  [STORE_HTTP_ERROR_INFO_EVENT]: (
    state: InitialStateNotification,
    action: PayloadAction<HTTPErrorInfoEvent>
  ) => {
    state.HTTPErrorInfoEvent = action.payload;
  },
});
